import { render, staticRenderFns } from "./PressItem.vue?vue&type=template&id=047b2810&scoped=true"
import script from "./PressItem.vue?vue&type=script&lang=js"
export * from "./PressItem.vue?vue&type=script&lang=js"
import style0 from "./PressItem.vue?vue&type=style&index=0&id=047b2810&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047b2810",
  null
  
)

export default component.exports